import { render } from "./rpjmn.vue?vue&type=template&id=4638b489"
import script from "./rpjmn.vue?vue&type=script&lang=js"
export * from "./rpjmn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__